import { useOrderApi } from "../api/OrderApiClient";
import { OrderFrontendService } from "../services/OrderFrontendService";

export const useOrderService = (): OrderFrontendService =>
  new OrderFrontendService(useOrderApi());
